// extracted by mini-css-extract-plugin
export default {"storeContainer":"Discover_storeContainer__L9iZm"};